import { render, staticRenderFns } from "./contentEditor.vue?vue&type=template&id=79cd8cbc&scoped=true&"
import script from "./contentEditor.ts?vue&type=script&lang=ts&"
export * from "./contentEditor.ts?vue&type=script&lang=ts&"
import style0 from "./contentEditor.scss?vue&type=style&index=0&id=79cd8cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cd8cbc",
  null
  
)

export default component.exports